import {
  ALERT_DATA_SUCCESS,
  ALERT_MULTIMEDIA_STATE_CHANGE,
  ALERT_SET_WARNING,
  ALERT_TOGGLE_UPDATE_ALERT,
  ALERT_TOGGLE_WARNING,
} from "../";

import dataJson from "./data.json";

export const getData = (ref: any) => {
  const { dispatch } = ref;

  const list = dataJson;

  const data = {
    list
  };

  dispatch({ type: ALERT_DATA_SUCCESS, payload: data, list });
};

let callBackFunction: any;

export const toggleWarning = (ref: any) => {
  const { dispatch, warningContent, callback } = ref;
  let { warningActive } = ref;
  warningActive = !warningActive;

  if (warningActive) {
    setWarningText({ dispatch, warningContent });
  } else {
    setWarningText({ dispatch, warningContent: { header: "", body: "" } });
  }

  if (callback === null) {
    callBackFunction = null;
  } else {
    callBackFunction = callback;
  }

  dispatch({
    type: ALERT_TOGGLE_WARNING,
    payload: warningActive
  });
};

export const multiMediaStateChange = (ref: any) => {
  const { dispatch, multiMedia, state, fileTypes } = ref;
  multiMedia.state = state;
  multiMedia.fileTypes = fileTypes;
  dispatch({
    type: ALERT_MULTIMEDIA_STATE_CHANGE,
    payload: JSON.parse(JSON.stringify(multiMedia))
  });
};

export const toggleUpdateAlert = (ref: any) => {
  const { dispatch, updateAlertState, warningContent } = ref;
  if (warningContent) {
    setWarningText({ dispatch, warningContent });
  }
  toggleUpdate({ dispatch, updateAlertState });
};

const toggleUpdate = (ref: any) => {
  const { dispatch, updateAlertState } = ref;
  dispatch({
    type: ALERT_TOGGLE_UPDATE_ALERT,
    payload: updateAlertState
  });
};

export const uploadMultiMedia = (ref: any) => {
  const { dispatch, files, multiMedia, id } = ref;

  const reader = new FileReader();
  let counter = 0;
  multiMedia.fileName = files[counter].name;
  reader.readAsDataURL(files[counter]);

  reader.onloadend = () => {
    const result = reader.result;
    multiMedia.files.push({
      name: files[counter].name,
      data: files[counter],
      src: result,
      size: Math.round(files[counter].size / 10000) / 100,
      type: files[counter].type,
      id
    });
    counter++;

    if (counter < files.length) {
      multiMedia.fileName = files[counter].name;
      reader.readAsDataURL(files[counter]);
    } else {
      multiMedia.uploadPercentage = null;
      multiMedia.fileName = null;
    }
    multiMedia.state = "init";
    dispatch({
      type: ALERT_MULTIMEDIA_STATE_CHANGE,
      payload: JSON.parse(JSON.stringify(multiMedia))
    });
  };

  reader.onprogress = evt => {
    let uploadPercentage = 0;
    uploadPercentage = Math.round(evt.loaded / evt.total * 100);
    multiMedia.uploadPercentage = uploadPercentage;
    dispatch({
      type: ALERT_MULTIMEDIA_STATE_CHANGE,
      payload: JSON.parse(JSON.stringify(multiMedia))
    });
  };
};

export const removeMultiMedia = (ref: any) => {
  const { dispatch, multiMedia, name } = ref;
  const files = multiMedia.files;

  const index = files
    .map((e: any) => {
      return e.name;
    })
    .indexOf(name);

  if (index > -1) {
    files.splice(index, 1);
  }

  multiMedia.files = files;

  dispatch({
    type: ALERT_MULTIMEDIA_STATE_CHANGE,
    payload: JSON.parse(JSON.stringify(multiMedia))
  });
};

export const warningAction = (ref: any) => {
  const { dispatch, action, warningActive } = ref;
  if (action && callBackFunction !== null) {
    callBackFunction();
  }
  callBackFunction = null;
  toggleWarning({ dispatch, warningActive });
};

export const setWarningText = (ref: any) => {
  const { dispatch, warningContent } = ref;
  dispatch({
    type: ALERT_SET_WARNING,
    payload: warningContent
  });
};



// WEBPACK FOOTER //
// ./src/actions/alerts/alerts-api.tsx